import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.api');
import { AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-api',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.api/view.scss */
:host {
  display: block;
  height: 100%;
}

.swagger-host {
  min-height: 100%;
}

:host ::ng-deep .swagger-ui {
  font-family: inherit;
}

:host ::ng-deep .swagger-ui .topbar {
  display: none;
}

:host ::ng-deep .swagger-ui .info {
  margin: 0 0 24px;
}

:host ::ng-deep .swagger-ui .scheme-container {
  box-shadow: none;
  margin: 0 0 16px;
}

:host ::ng-deep .swagger-ui .wrapper {
  max-width: none;
  padding: 0 16px 24px;
}

.tta-performance-panel {
  margin: 8px 8px 24px;
  padding: 20px;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: #eff6ff;
  color: #172554;
}

.tta-performance-panel h2 {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
}

.tta-description,
.tta-profile-row p,
.tta-reference {
  margin: 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.6;
}

.tta-profile-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
}

.tta-profile-output,
.tta-output {
  display: block;
  width: 100%;
  margin: 10px 0 0;
  padding: 12px;
  overflow: auto;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #0f172a;
  color: #e2e8f0;
  font: 12px/1.55 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: pre-wrap;
}

.tta-profile-output {
  min-height: 44px;
  background: #dbeafe;
  color: #172554;
}

.tta-output {
  min-height: 176px;
}

.tta-output-pass {
  border-color: #34d399;
}

.tta-output-fail {
  border-color: #fb7185;
}

.tta-test-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.tta-test-card {
  padding: 18px;
  border: 1px solid #93c5fd;
  border-radius: 10px;
  background: #fff;
}

.tta-test-card h3 {
  margin: 0 0 5px;
  font-size: 17px;
  font-weight: 700;
}

.tta-field-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  margin-top: 12px;
}

.tta-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #172554;
  font-size: 12px;
  font-weight: 700;
}

.tta-field input {
  min-height: 38px;
  width: 100%;
  padding: 7px 9px;
  border: 1px solid #93c5fd;
  border-radius: 7px;
  background: #fff;
  color: #172554;
}

.tta-button {
  min-height: 38px;
  width: 100%;
  margin-top: 11px;
  padding: 8px 14px;
  border: 0;
  border-radius: 7px;
  background: #1d4ed8;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.tta-button-secondary {
  width: auto;
  min-width: 132px;
  margin-top: 0;
  background: #475569;
}

.tta-button:disabled {
  cursor: wait;
  opacity: 0.55;
}

@media (max-width: 960px) {
  .tta-test-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .tta-profile-row {
    align-items: stretch;
    flex-direction: column;
  }
  .tta-field-grid {
    grid-template-columns: 1fr;
  }
  .tta-button-secondary {
    width: 100%;
  }
}`],
})
export class PageKieraApiComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('swaggerContainer') public swaggerContainer?: ElementRef<HTMLDivElement>;

    public readonly webhookStatusLabels: any = {pending: '대기', sending: '전송 중', retry: '재시도 대기', sent: '전송 완료', dead: '실패', cancelled: '취소'};
    public webhookBusy = false;
    public webhookError = '';
    public webhookSecret = '';
    public webhookRows: any[] = [];
    public webhookDeliveries: any[] = [];
    public webhookDraft: any = { id: '', url: '', events: ['node.status.changed'], enabled: false, secret: '' };
    public readonly webhookEvents = ['node.status.changed', 'deploy.completed', 'juju.registration.changed', 'relay.group.updated', 'image.lifecycle.changed'];
    public get webhookAdmin(): boolean { return this.service.auth.check.role('superadmin'); }
    public resetWebhook() {
        this.webhookDraft = { id: '', url: '', events: ['node.status.changed'], enabled: false, secret: '' };
        this.webhookSecret = '';
    }
    public editWebhook(row: any) {
        this.webhookDraft = { ...row, events: [...row.events], secret: '' };
        this.webhookSecret = '';
    }
    public async webhookAction(action: string, row?: any) {
        if (this.webhookBusy || !this.webhookAdmin) return;
        if (action === 'remove' && !window.confirm(this.service.lang.localize('이 Webhook 구독을 삭제하시겠습니까?'))) return;
        this.webhookBusy = true; this.webhookError = ''; this.webhookSecret = '';
        try {
            if (action !== 'load') {
                const fields = action === 'save' ? { config: JSON.stringify(this.webhookDraft) } : { id: row.id };
                const response = await wiz.call('webhook_' + action, fields);
                if (response.code !== 200) throw new Error(response.data?.message || 'Webhook 요청에 실패했습니다.');
                if (action === 'save') {
                    const data = response.data || {};
                    this.webhookSecret = data.secret && data.secret !== '********' ? data.secret : '';
                    this.webhookDraft = { ...data, secret: '' };
                }
                if (action === 'remove' && this.webhookDraft.id === row.id) this.resetWebhook();
            }
            const response = await wiz.call('webhook_list');
            if (response.code !== 200) throw new Error(response.data?.message || 'Webhook 요청에 실패했습니다.');
            this.webhookRows = response.data?.rows || [];
            const history = await wiz.call('webhook_deliveries');
            if (history.code !== 200) throw new Error(history.data?.message || 'Webhook 요청에 실패했습니다.');
            this.webhookDeliveries = history.data?.rows || [];
        } catch (error: any) {
            this.webhookError = error?.message || String(error);
        } finally {
            this.webhookBusy = false; await this.service.render();
        }
    }

    public loading: boolean = false;
    public error: string = '';
    public authStatus: string = '';
    public authScopes: string = '';
    public authError: string = '';
    public authRefreshing: boolean = false;
    public ttaBusy: '' | 'profile' | 'single' | 'list' = '';
    public ttaNodeId: number = 143;
    public ttaSingleWarmup: number = 10;
    public ttaSingleSamples: number = 100;
    public ttaListPages: number = 10;
    public ttaListWarmup: number = 10;
    public ttaListSamples: number = 100;
    public ttaProfileReady: boolean | null = null;
    public ttaSinglePassed: boolean | null = null;
    public ttaListPassed: boolean | null = null;
    public ttaProfileOutput: string = '시험 전 registered_nodes>=1000, fixture_nodes>=897, ready=true를 확인하십시오.';
    public ttaSingleOutput: string = '단일 노드 결과만 이 영역에 표시됩니다.';
    public ttaListOutput: string = '목록 결과만 이 영역에 표시됩니다.';
    public readonly openapiUrl: string = '/api/v1/openapi.json';
    private readonly ttaApiBaseUrl: string = '/api/v1';
    private readonly swaggerCssUrl: string = '/assets/swagger-ui/swagger-ui.css';
    private readonly swaggerCssId: string = 'kiera-swagger-ui-css';
    private swaggerUi: any = null;
    private openapiSpec: any = null;
    private swaggerToken: string = '';
    private authRefreshTimer: number | null = null;
    private langSub?: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        if (this.webhookAdmin) await this.webhookAction('load');
        this.langSub = this.translate.onLangChange.subscribe(async () => {
            await this.reloadSwagger();
        });
        await this.service.render();
    }

    public async ngAfterViewInit() {
        await this.mountSwagger();
    }

    public ngOnDestroy() {
        if (this.langSub) this.langSub.unsubscribe();
        if (this.authRefreshTimer !== null) window.clearTimeout(this.authRefreshTimer);
        this.destroySwagger();
    }

    public async mountSwagger() {
        if (!this.swaggerContainer?.nativeElement) return;

        this.ensureSwaggerStylesheet();
        this.destroySwagger();
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            // Swagger UI is only used on /kiera/swagger. Loading its ~1.8 MB
            // implementation in the initial SPA bundle delayed every first
            // visit, including the dashboard and cluster pages.
            const [swaggerBundleModule, swaggerPresetModule] = await Promise.all([
                import('swagger-ui-dist/swagger-ui-bundle.js'),
                import('swagger-ui-dist/swagger-ui-standalone-preset.js'),
            ]);
            const SwaggerUIBundle = swaggerBundleModule.default;
            const SwaggerUIStandalonePreset = swaggerPresetModule.default;
            const spec = await this.fetchOpenApiSpec(true);
            try {
                await this.fetchSwaggerAuthorization();
            } catch (authError: any) {
                this.swaggerToken = '';
                this.authStatus = '';
                this.authError = authError?.message || '로그인 세션을 Public API 인증으로 전환하지 못했습니다.';
            }
            this.swaggerUi = SwaggerUIBundle({
                domNode: this.swaggerContainer.nativeElement,
                spec: spec,
                deepLinking: true,
                displayRequestDuration: true,
                persistAuthorization: false,
                filter: true,
                tryItOutEnabled: true,
                docExpansion: 'list',
                defaultModelsExpandDepth: 1,
                presets: [
                    SwaggerUIBundle.presets.apis,
                    SwaggerUIStandalonePreset,
                ],
                layout: 'StandaloneLayout',
                validatorUrl: null,
                requestInterceptor: (request: any) => {
                    request.credentials = 'include';
                    request.headers = request.headers || {};
                    if (String(request.method || '').toUpperCase() === 'GET' && !String(request.url || '').includes('/openapi.json')) {
                        request.url = this.withTimingQuery(request.url);
                    }
                    if (!request.headers['X-Trace-Id'] && !request.headers['x-trace-id']) {
                        request.headers['X-Trace-Id'] = this.createTraceId();
                    }
                    const hasBearer = request.headers.Authorization || request.headers.authorization;
                    const hasApiKey = request.headers['X-API-Key'] || request.headers['x-api-key'];
                    if (this.swaggerToken && !hasBearer && !hasApiKey) {
                        request.headers.Authorization = `Bearer ${this.swaggerToken}`;
                    }
                    return request;
                },
                onComplete: () => this.applySwaggerAuthorization(),
            });
            this.applySwaggerAuthorization();
        } catch (e: any) {
            this.error = e?.message || this.translate.instant('page.api.error_init');
        }

        this.loading = false;
        await this.service.render();
    }

    public async reloadSwagger() {
        this.openapiSpec = null;
        await this.mountSwagger();
    }

    public async refreshSwaggerAuthorization(silent: boolean = false) {
        if (this.authRefreshing) return;
        this.authRefreshing = true;
        if (!silent) this.authError = '';
        await this.service.render();

        try {
            await this.fetchSwaggerAuthorization();
            this.applySwaggerAuthorization();
        } catch (e: any) {
            this.authError = e?.message || '로그인 세션을 Public API 인증으로 전환하지 못했습니다.';
        }

        this.authRefreshing = false;
        await this.service.render();
    }

    public async openSpec() {
        const spec = await this.fetchOpenApiSpec();
        const blob = new Blob([JSON.stringify(spec, null, 2)], { type: 'application/json' });
        const blobUrl = URL.createObjectURL(blob);
        const specTab = window.open(blobUrl, '_blank', 'noopener,noreferrer');
        if (specTab) {
            specTab.opener = null;
        }
        window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    }

    public async checkTtaPerformanceProfile() {
        if (this.ttaBusy) return;
        this.ttaBusy = 'profile';
        this.ttaProfileReady = null;
        this.ttaProfileOutput = '최소 1,000노드 시험 환경을 확인하는 중입니다...';
        await this.service.render();

        try {
            const nodeId = this.ttaNumber(this.ttaNodeId, 143, 1, Number.MAX_SAFE_INTEGER);
            this.ttaNodeId = nodeId;
            await this.loadTtaPerformanceProfile(nodeId);
        } catch (error: any) {
            this.ttaProfileReady = false;
            this.ttaProfileOutput = `환경 확인 실패: ${error?.message || error}`;
        } finally {
            this.ttaBusy = '';
            await this.service.render();
        }
    }

    public async runTtaSingleNodePerformanceTest() {
        if (this.ttaBusy) return;
        const nodeId = this.ttaNumber(this.ttaNodeId, 143, 1, Number.MAX_SAFE_INTEGER);
        this.ttaNodeId = nodeId;
        this.ttaSinglePassed = null;

        await this.executeTtaPerformanceCase({
            kind: 'single',
            name: '단일 노드 DB 상태',
            api: `GET /nodes/${nodeId}/status?compact=1`,
            targetMs: 200,
            warmup: this.ttaNumber(this.ttaSingleWarmup, 10, 0, 100),
            samples: this.ttaNumber(this.ttaSingleSamples, 100, 1, 1000),
            profileNodeId: nodeId,
            pathForIndex: (_index: number, testNodeId: number) => `/nodes/${testNodeId}/status?compact=1`,
            expectsAcceleration: true,
            validate: (result: any, testNodeId: number) => {
                const data = result.envelope?.data || {};
                if (Number(data.id) !== testNodeId) {
                    throw new Error(`노드 응답 불일치: expected=${testNodeId}, actual=${data.id}`);
                }
                const fields = Object.keys(data).sort().join(',');
                if (fields !== 'id,power_status,status,updated') {
                    throw new Error(`compact 응답 필드 불일치: ${fields}`);
                }
            },
        });
    }

    public async runTtaListPerformanceTest() {
        if (this.ttaBusy) return;
        const nodeId = this.ttaNumber(this.ttaNodeId, 143, 1, Number.MAX_SAFE_INTEGER);
        const pages = this.ttaNumber(this.ttaListPages, 10, 1, 10);
        this.ttaNodeId = nodeId;
        this.ttaListPages = pages;
        this.ttaListPassed = null;

        await this.executeTtaPerformanceCase({
            kind: 'list',
            name: '노드 목록 100개/page',
            api: `GET /nodes?page={1..${pages}}&dump=100`,
            targetMs: 1000,
            warmup: this.ttaNumber(this.ttaListWarmup, 10, 0, 100),
            samples: this.ttaNumber(this.ttaListSamples, 100, 1, 1000),
            profileNodeId: nodeId,
            pathForIndex: (index: number, _testNodeId: number) => `/nodes?page=${(index % pages) + 1}&dump=100`,
            validate: (result: any) => {
                const data = result.envelope?.data || {};
                const items = Array.isArray(data.items) ? data.items : [];
                const pagination = result.envelope?.pagination || {};
                if (items.length !== 100 || Number(pagination.total) < 1000) {
                    throw new Error(
                        `최소 1,000노드/100개 페이지 조건 불일치: items=${items.length}, total=${pagination.total}`
                    );
                }
            },
        });
    }

    private async executeTtaPerformanceCase(options: {
        kind: 'single' | 'list';
        name: string;
        api: string;
        targetMs: number;
        warmup: number;
        samples: number;
        profileNodeId: number;
        pathForIndex: (index: number, testNodeId: number) => string;
        expectsAcceleration?: boolean;
        validate?: (result: any, testNodeId: number) => void;
    }) {
        this.ttaBusy = options.kind;
        this.setTtaOutput(options.kind, `${options.name}: 워밍업 ${options.warmup}회 진행 중...`);
        await this.service.render();

        try {
            await this.ensureTtaAuthorization();
            const dataset = await this.loadTtaPerformanceProfile(options.profileNodeId);
            if (dataset.ready !== true) {
                throw new Error('TTA 시험 환경이 NOT READY입니다. 최소 1,000노드 조건을 먼저 충족해야 합니다.');
            }
            const testNodeId = this.ttaNumber(dataset.test_node_id, options.profileNodeId, 1, Number.MAX_SAFE_INTEGER);
            this.ttaNodeId = testNodeId;
            for (let index = 0; index < options.warmup; index += 1) {
                const result = await this.ttaGet(options.pathForIndex(index, testNodeId));
                if (options.validate) options.validate(result, testNodeId);
            }

            const clientValues: number[] = [];
            const serverValues: number[] = [];
            let acceleratedResponses = 0;
            for (let index = 0; index < options.samples; index += 1) {
                const result = await this.ttaGet(options.pathForIndex(index, testNodeId));
                if (options.validate) options.validate(result, testNodeId);
                clientValues.push(result.elapsed);
                if (Number.isFinite(result.serverTotal)) serverValues.push(result.serverTotal);
                if (result.accelerated) acceleratedResponses += 1;

                if ((index + 1) % 5 === 0 || index + 1 === options.samples) {
                    this.setTtaOutput(options.kind, `${options.name}: ${index + 1}/${options.samples}회 측정 중...`);
                    await this.service.render();
                    await new Promise<void>((resolve) => window.requestAnimationFrame(() => resolve()));
                }
            }

            const client = this.ttaStats(clientValues);
            const server = serverValues.length ? this.ttaStats(serverValues) : null;
            const passed = client.p95 <= options.targetMs;
            const serverPassed = server ? server.p95 <= options.targetMs : null;
            const measuredApi = options.kind === 'single'
                ? `GET /nodes/${testNodeId}/status?compact=1`
                : options.api;
            const lines = [
                `측정 API: ${measuredApi}`,
                '환경 사전검사: READY (측정 표본에서 제외)',
                '다른 API와 합산: 하지 않음',
                `워밍업/표본: ${options.warmup}/${options.samples}회`,
                `TTA client 판정: ${passed ? 'PASS' : 'FAIL'} (목표 P95 ≤ ${options.targetMs}ms)`,
                `client 종단간: ${this.formatTtaStats(client)}`,
            ];
            if (server) {
                lines.push(`server X-Response-Time-Ms: ${this.formatTtaStats(server)}`);
                lines.push(`DB API server 판정: ${serverPassed ? 'PASS' : 'FAIL'} (병목 구분용)`);
            }
            if (options.expectsAcceleration) {
                lines.push(
                    `DB-only 전용 경량 경로: ${acceleratedResponses}/${options.samples}회 적용` +
                    (acceleratedResponses === options.samples ? ' (정상)' : ' (배포 상태 확인 필요)')
                );
            }
            if (!passed && serverPassed) {
                lines.push('해석: API server는 목표 이내이며 브라우저·proxy·network 구간에서 기준을 초과했습니다.');
            }

            if (options.kind === 'single') this.ttaSinglePassed = passed;
            else this.ttaListPassed = passed;
            this.setTtaOutput(options.kind, lines.join('\n'));
        } catch (error: any) {
            if (options.kind === 'single') this.ttaSinglePassed = false;
            else this.ttaListPassed = false;
            this.setTtaOutput(options.kind, `시험 중단: ${error?.message || error}`);
        } finally {
            this.ttaBusy = '';
            await this.service.render();
        }
    }

    private async loadTtaPerformanceProfile(nodeId: number) {
        const result = await this.ttaGet(`/tta/performance-profile?node_id=${nodeId}`);
        const profile = result.envelope?.data || {};
        const dataset = profile.dataset || {};
        const testNodeId = Number(dataset.test_node_id);
        if (Number.isFinite(testNodeId) && testNodeId > 0) this.ttaNodeId = Math.floor(testNodeId);
        this.ttaProfileReady = dataset.ready === true;
        this.ttaProfileOutput = [
            `registered_nodes=${dataset.registered_nodes}`,
            `fixture_nodes=${dataset.fixture_nodes}`,
            `expected_registered_nodes=${dataset.expected_registered_nodes}`,
            `expected_fixture_nodes=${dataset.expected_fixture_nodes}`,
            `requested_node_id=${dataset.requested_node_id}`,
            `requested_node_exists=${dataset.requested_node_exists}`,
            `test_node_id=${dataset.test_node_id}`,
            `readiness_rule=${dataset.readiness_rule || 'minimum'}`,
            `ready=${dataset.ready}`,
            `api_version=${profile.api_version || '-'}`,
            `환경 판정: ${this.ttaProfileReady ? 'READY' : 'NOT READY'}`,
        ].join('\n');
        return dataset;
    }

    private async ensureTtaAuthorization() {
        if (!this.swaggerToken) {
            await this.fetchSwaggerAuthorization();
            this.applySwaggerAuthorization();
        }
        if (!this.swaggerToken) throw new Error('Swagger 자동 인증 토큰을 발급받지 못했습니다.');
    }

    private async ttaGet(path: string) {
        await this.ensureTtaAuthorization();
        const started = performance.now();
        let response: Response;
        try {
            response = await fetch(this.ttaApiBaseUrl + path, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${this.swaggerToken}`,
                    'X-Trace-Id': this.createTraceId(),
                },
                cache: 'no-store',
                credentials: 'same-origin',
            });
        } catch (error: any) {
            throw new Error(`API 연결 오류: ${error?.message || error}`);
        }

        let payload: any;
        try {
            payload = await response.json();
        } catch {
            throw new Error(`JSON 응답 형식 오류 (HTTP ${response.status})`);
        }
        const elapsed = performance.now() - started;
        const logicalCode = payload?.code !== undefined ? Number(payload.code) : response.status;
        const envelope = payload?.code !== undefined && payload?.data ? payload.data : payload;
        if (!response.ok || logicalCode !== 200 || envelope?.success !== true) {
            const message = envelope?.error?.message || payload?.message || 'API 요청이 실패했습니다.';
            throw new Error(`HTTP ${response.status}, 논리 코드 ${logicalCode}: ${message}`);
        }

        const rawServerTotal = response.headers.get('X-Response-Time-Ms');
        const serverTotal = rawServerTotal === null || rawServerTotal === '' ? NaN : Number(rawServerTotal);
        return {
            elapsed,
            envelope,
            serverTotal,
            accelerated: response.headers.get('X-KiERA-Node-Status-Accelerated') === '1',
        };
    }

    private ttaNumber(value: any, fallback: number, minimum: number, maximum: number) {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) return fallback;
        return Math.min(maximum, Math.max(minimum, Math.floor(parsed)));
    }

    private ttaPercentile(values: number[], percent: number) {
        const ordered = values.slice().sort((left, right) => left - right);
        const position = (ordered.length - 1) * percent / 100;
        const lower = Math.floor(position);
        const upper = Math.ceil(position);
        if (lower === upper) return ordered[lower];
        return ordered[lower] + (ordered[upper] - ordered[lower]) * (position - lower);
    }

    private ttaStats(values: number[]) {
        return {
            min: Math.min(...values),
            avg: values.reduce((sum, value) => sum + value, 0) / values.length,
            p50: this.ttaPercentile(values, 50),
            p95: this.ttaPercentile(values, 95),
            p99: this.ttaPercentile(values, 99),
            max: Math.max(...values),
        };
    }

    private formatTtaStats(value: { min: number; avg: number; p50: number; p95: number; p99: number; max: number }) {
        return [
            `min ${value.min.toFixed(2)}`,
            `avg ${value.avg.toFixed(2)}`,
            `P50 ${value.p50.toFixed(2)}`,
            `P95 ${value.p95.toFixed(2)}`,
            `P99 ${value.p99.toFixed(2)}`,
            `max ${value.max.toFixed(2)} ms`,
        ].join(' / ');
    }

    private setTtaOutput(kind: 'single' | 'list', value: string) {
        if (kind === 'single') this.ttaSingleOutput = value;
        else this.ttaListOutput = value;
    }

    private destroySwagger() {
        if (this.swaggerUi && typeof this.swaggerUi.destroy === 'function') {
            this.swaggerUi.destroy();
        }
        this.swaggerUi = null;
        if (this.swaggerContainer?.nativeElement) {
            this.swaggerContainer.nativeElement.innerHTML = '';
        }
    }

    private ensureSwaggerStylesheet() {
        if (document.getElementById(this.swaggerCssId)) return;

        const link = document.createElement('link');
        link.id = this.swaggerCssId;
        link.rel = 'stylesheet';
        link.href = this.swaggerCssUrl;
        document.head.appendChild(link);
    }

    private withTimingQuery(rawUrl: string) {
        try {
            const url = new URL(String(rawUrl || ''), window.location.origin);
            if (!url.searchParams.has('timing')) url.searchParams.set('timing', 'true');
            return url.toString();
        } catch {
            const separator = String(rawUrl || '').includes('?') ? '&' : '?';
            return String(rawUrl || '') + separator + 'timing=true';
        }
    }

    private createTraceId() {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID().replace(/-/g, '');
        }
        return String(Date.now()) + Math.random().toString(16).slice(2);
    }

    private async fetchSwaggerAuthorization() {
        const response: any = await wiz.call('authorize');
        if (response?.code !== 200 || !response?.data?.access_token) {
            throw new Error(response?.data?.message || `인증 토큰 발급 실패 (${response?.code || 'unknown'})`);
        }

        const data = response.data;
        this.swaggerToken = String(data.access_token);
        this.authStatus = `자동 인증 ${data.role || 'viewer'} · ${data.expires_at || '15분'}`;
        this.authScopes = `Scopes: ${Array.isArray(data.scopes) ? data.scopes.join(', ') : data.scopes || ''}`;
        this.authError = '';
        this.scheduleAuthRefresh(Number(data.expires_in || 900));
    }

    private scheduleAuthRefresh(expiresIn: number) {
        if (this.authRefreshTimer !== null) window.clearTimeout(this.authRefreshTimer);
        const refreshAfter = Math.max(60, expiresIn - 60) * 1000;
        this.authRefreshTimer = window.setTimeout(async () => {
            await this.refreshSwaggerAuthorization(true);
        }, refreshAfter);
    }

    private applySwaggerAuthorization() {
        if (!this.swaggerUi || !this.swaggerToken) return;
        const scheme = this.openapiSpec?.components?.securitySchemes?.bearerAuth;
        if (scheme && this.swaggerUi.authActions?.authorize) {
            this.swaggerUi.authActions.authorize({
                bearerAuth: {
                    name: 'bearerAuth',
                    schema: scheme,
                    value: this.swaggerToken,
                },
            });
        }
    }

    private async fetchOpenApiSpec(forceReload: boolean = false) {
        if (!forceReload && this.openapiSpec) {
            return this.openapiSpec;
        }

        const response = await fetch(this.openapiUrl, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(this.translate.instant('page.api.error_fetch', { status: response.status }));
        }

        const payload = await response.json();
        const spec = payload?.data?.openapi || payload?.data?.swagger ? payload.data : payload;
        if (!spec?.openapi && !spec?.swagger) {
            throw new Error(this.translate.instant('page.api.error_format'));
        }

        const localized = this.localizeSpec(spec);
        this.openapiSpec = localized;
        return localized;
    }

    private isEnglishLanguage() {
        return String(this.translate.currentLang || this.translate.getDefaultLang() || 'ko').toLowerCase().startsWith('en');
    }

    private localizeText(value: string) {
        if (!this.isEnglishLanguage()) return value;

        const replacements: Array<[string, string]> = [
            ['KiERA 외부 연동용 표준 Web API 1차 스펙', 'First standard Web API specification for KiERA external integrations'],
            ['성공 응답', 'Success response'],
            ['오류 응답', 'Error response'],
            ['쉼표 구분 scope 목록', 'Comma-separated scope list'],
            ['토큰 만료 시간(초)', 'Token expiration time (seconds)'],
            ['기존 login 또는 refresh 응답에서 받은 refresh token', 'Refresh token returned by a previous login or refresh response'],
            ['선택 사항. 좁은 scope로 재발급할 때 사용', 'Optional. Use this to reissue with narrower scopes'],
            ['새 access token 만료 시간(초)', 'New access token expiration time (seconds)'],
            ['JSON body가 아니라 form-urlencoded 요청만 지원합니다.', 'Only form-urlencoded requests are supported, not JSON bodies.'],
            ['JSON 배열 문자열. 예: ', 'JSON array string. Example: '],
            ['JSON 객체 문자열. ', 'JSON object string. '],
            ['개별 필드 대신 전체 payload를 JSON 문자열로 전달할 때 사용', 'Use this to send the full payload as a JSON string instead of individual fields'],
            ['액션별 추가 옵션', 'Additional options per action'],
            ['기본값은 queued입니다. 테스트/점검 시 sync 또는 direct를 지정하면 기존 동기 실행 경로를 사용합니다.', 'The default is queued. For testing or inspection, use sync or direct to use the legacy synchronous execution path.'],
            ['true이면 큐 등록 직후 opportunistic worker를 한 번 실행합니다. 운영 기본값은 false입니다.', 'If true, the opportunistic worker runs once immediately after queue registration. The operational default is false.'],
            ['email, username, id 중 하나와 password를 form-urlencoded로 전달합니다.', 'Send one of email, username, or id together with password as form-urlencoded data.'],
            ['특정 사용자 기준으로 API key를 필터링합니다.', 'Filters API keys for a specific user.'],
            ['폐기할 credential id', 'Credential id to revoke'],
            ['JWT 발급', 'Issue JWT'],
            ['JWT 재발급', 'Refresh JWT'],
            ['API Key 목록', 'List API Keys'],
            ['API Key 생성', 'Create API Key'],
            ['API Key 폐기', 'Revoke API Key'],
            ['JWT 발급 성공', 'JWT issued successfully'],
            ['JWT 재발급 성공', 'JWT refreshed successfully'],
            ['인증 입력 오류', 'Authentication input error'],
            ['입력 오류', 'Input error'],
            ['refresh token 오류', 'Refresh token error'],
            ['API key 목록 조회 성공', 'API key list retrieved successfully'],
            ['API key 생성 성공', 'API key created successfully'],
            ['API key 폐기 성공', 'API key revoked successfully'],
            ['인증 실패', 'Authentication failed'],
            ['예: deploy, release, commission, power-on, power-cycle', 'Examples: deploy, release, commission, power-on, power-cycle'],
            ['deploy/release/commission 전용 추가 옵션', 'Additional options used by deploy/release/commission'],
            ['JSON 객체 문자열. 액션별 추가 옵션', 'JSON object string. Additional options per action'],
            ['노드', 'Node'],
            ['이미지', 'Image'],
            ['그룹', 'Group'],
            ['클러스터', 'Cluster'],
            ['릴레이', 'Relay'],
            ['배포', 'Deploy'],
            ['조회', 'Retrieve'],
            ['목록', 'List'],
            ['생성', 'Create'],
            ['폐기', 'Revoke'],
            ['상태', 'Status'],
            ['요약', 'Summary'],
            ['검사', 'Inspect'],
            ['실행', 'Execute'],
        ];

        let text = String(value ?? '');
        for (const [source, target] of replacements) {
            text = text.split(source).join(target);
        }
        return text;
    }

    private localizeSpec(spec: any) {
        const cloned = JSON.parse(JSON.stringify(spec || {}));
        return this.localizeValue(cloned);
    }

    private localizeValue(value: any): any {
        if (typeof value === 'string') return this.localizeText(value);
        if (Array.isArray(value)) return value.map((item) => this.localizeValue(item));
        if (value && typeof value === 'object') {
            return Object.keys(value).reduce((result: any, key: string) => {
                result[key] = this.localizeValue(value[key]);
                return result;
            }, {});
        }
        return value;
    }
}

export default PageKieraApiComponent;
